import { useEffect } from 'react';

//used just variable instead of state to return always false after first usage of hook
let isSsr = true;

function useIsSsr() {
  useEffect(() => {
    isSsr = false;
  }, []);

  return isSsr;
}

export default useIsSsr;
